import { Button, Card, Col, Row, Tooltip } from 'antd'
import { CloudDownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import React, { useState } from 'react'
import { useMyContext } from 'Context/MyContextProvider';
import ScheduleCampainTable from './ScheduleCampainTable';

const ScheduleCampaign = () => {

    const { HandleExport } = useMyContext();
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [listLoading, setListLoading] = useState(false);

    // useEffect(() => {
    //     if (!Permisson?.includes('View Campaign History')) {
    //         navigate('404')
    //     }
    // }, [Permisson]);


    return (
        <Card bodyStyle={{ padding: '0px' }}>
            <div className="container-fluid">
                <Row justify="space-between" align="middle" className="py-4">
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <h2 style={{ margin: 0 }}>Schedule Campaign</h2>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Row gutter={[8, 8]} justify="end" align="middle">
                            <Col xs={6} sm={4} md={3} lg={3}>
                                <Tooltip title="Refresh">
                                    <Button
                                        icon={<ReloadOutlined />}
                                        onClick={() => setRefreshTrigger((prev) => prev + 1)}
                                        loading={listLoading}
                                        block
                                    />
                                </Tooltip>
                            </Col>
                            <Col xs={18} sm={10} md={9} lg={9}>
                                <Button
                                    icon={<CloudDownloadOutlined />}
                                    onClick={() => HandleExport('export-campaign', 'campaigns.xlsx')}
                                    block
                                >
                                    Export Report
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            <ScheduleCampainTable
                refreshTrigger={refreshTrigger}
                onLoadingChange={setListLoading}
            />
        </Card >
    )
}

export default ScheduleCampaign
